<!-- Avatar Change Modal -->
<div class="modal fade" id="avatarChangeModal" tabindex="-1" aria-labelledby="avatarChangeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-dark text-white border-secondary">
            <div class="modal-header border-secondary">
                <h5 class="modal-title fw-bold" id="avatarChangeModalLabel">Change Avatar</h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body p-4">
                <div class="row align-items-center mb-4">
                    <div class="col-md-3 col-sm-4 text-center">
                        <img [src]="newAvatarUrl()" class="rounded-circle shadow border border-3 border-danger"
                            style="width: 75px; height: 75px; object-fit: cover;" alt="Avatar Preview" #avatarPreview
                            (error)="avatarPreview.src = currentUser().avatar">
                        <p class="mt-1 text-muted small mb-0">Preview</p>
                    </div>
                    <div class="col-md-9 col-sm-8">
                        @if(isAdmin()) {
                        <p class="text-muted mb-3">Choose a portrait from the categories below or provide a direct image URL.</p>
                        <div class="form-floating">
                            <input type="text" class="form-control bg-dark text-white border-secondary" id="avatarUrlInput" placeholder="Avatar URL"
                                [ngModel]="newAvatarUrl()" (ngModelChange)="newAvatarUrl.set($event); selectedPortraitId.set(null)">
                            <label for="avatarUrlInput">Custom Image URL</label>
                        </div>
                        } @else {
                        <p class="text-muted mb-0">Select a portrait from the collection below to update your profile avatar.</p>
                        }
                    </div>
                </div>

                <div class="categories-nav mb-3 d-flex flex-wrap gap-2">
                    @for(cat of categories(); track cat) {
                    <button class="btn btn-sm" 
                        [class.btn-danger]="selectedCategory() === cat"
                        [class.btn-dark]="selectedCategory() !== cat"
                        (click)="selectedCategory.set(cat)">
                        {{ cat }}
                    </button>
                    }
                </div>

                <div class="portrait-grid mb-0 overflow-y-auto overflow-x-hidden px-1 border border-dark rounded" 
                    style="max-height: 400px; background-color: rgba(0,0,0,0.2); border-color: #1a1a1a !important;">
                    <div class="row g-3 p-3">
                        @for(portrait of filteredPortraits(); track portrait.id) {
                        <div class="col-6 col-sm-4 col-md-3 col-lg-2">
                            <div class="portrait-item rounded overflow-hidden cursor-pointer h-100" 
                                [class.border]="selectedPortraitId() === portrait.id"
                                [class.border-danger]="selectedPortraitId() === portrait.id"
                                [class.border-3]="selectedPortraitId() === portrait.id"
                                (click)="selectPortrait(portrait)">
                                <img [src]="'https://static.h5arena.com/images/avatars/' + portrait.fileName" 
                                    class="img-fluid w-100 h-100 object-fit-cover" [alt]="portrait.title" title="{{portrait.title}}">
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="changeAvatar()" data-bs-dismiss="modal">Save Changes</button>
            </div>
        </div>
    </div>
</div>
